import { render, staticRenderFns } from "./ClosedFilesReport.vue?vue&type=template&id=5fe13b76"
import script from "./ClosedFilesReport.vue?vue&type=script&lang=js"
export * from "./ClosedFilesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports